import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RecentQuotes, { IRecentlyOpenedQuote } from "../../../api/apiRecentQuotes";
import DashboardContainer from "../Container";
import "../style-lists.scss";

// The last 10 quotes the signed in user opened (stored per user in thanos26). A click opens the quote for editing.
function ContainerRecentQuotes(props: { classes: string }) {
    const [quotes, setQuotes] = useState<IRecentlyOpenedQuote[]>([]);
    const [laden, setLaden] = useState<boolean>(true);
    const [fehler, setFehler] = useState<string>("");

    useEffect(() => {
        RecentQuotes.getRecentlyOpened()
            .then((liste) => {
                setQuotes(liste ?? []);
                setFehler("");
            })
            .catch((error) => {
                console.error(error);
                setFehler(`Offerten konnten nicht geladen werden: ${error?.message ?? error}`);
            })
            .finally(() => setLaden(false));
    }, []);

    const quoteList = quotes.map((quote) => (
        <Link
            key={`${quote.id}-${quote.version}`}
            className="ds-list__item"
            title={`Offerte ${quote.id} / Version ${quote.version} öffnen`}
            to={`/offer/${quote.id}/${quote.version}`}>
            <span className="ds-list__primary" title={quote.kunde ?? ""}>
                {quote.kunde ?? "–"}
            </span>
            <span title={quote.projekt ?? ""}>{quote.projekt ?? "–"}</span>
            <span title={quote.offerte ?? ""}>{quote.offerte || `#${quote.id} v${quote.version}`}</span>
        </Link>
    ));

    let inhalt: React.ReactNode = quoteList;
    if (fehler) inhalt = <div className="ds-list__empty ds-list__error">{fehler}</div>;
    else if (laden) inhalt = <div className="ds-list__empty">Offerten werden geladen ...</div>;
    else if (quoteList.length === 0) inhalt = <div className="ds-list__empty">Keine zuletzt geöffneten Quotes</div>;

    return (
        <DashboardContainer headerName="RECENTLY OPENED QUOTES" className={`ds-list ds-recentquotes ${props.classes}`}>
            <div className="ds-list__head">
                <span>Kunde</span>
                <span>Projekt</span>
                <span>Quote</span>
            </div>
            {inhalt}
        </DashboardContainer>
    );
}

export default ContainerRecentQuotes;
